import React, { useEffect, useState } from "react";
import Faq from "../components/Faq/Faq";
import { diagnosticFeatures, features, videoCards } from "./data";
import diagnosticBg from "./img/diagnostic-bg.png";
import desktopDevice from "./img/desktop-device.png";
import SectionHeader from "@components/SectionHeader";
import "./style.scss";
import { useOutletContext, useSearchParams } from "react-router-dom";
import VideoCard from "../components/VideoCard";
import { useWindowSize } from "@app/Helpers";
import DownloadSlider from "../components/DownloadSlider";
import { getActivationDescribe } from "@api/activation";
import Button from "@components/Button";
import Logo from "./img/MYVUSE-App-logo.svg?react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import ArrowButton from "../components/ArrowButton";

export default function UltraCare() {
  const ultraInsider = useOutletContext();
  const sliderRef = React.useRef(null);
  const [activationData, setActivationData] = useState({});
  const [loadingActivations, setLoadingActivations] = useState(false);

  const { width } = useWindowSize();
  const XGA = width >= 1020;

  const [searchParams, setSearchParams] = useSearchParams();

  const ident = searchParams.get("ident") || false;

  const fetchAllActivations = async () => {
    if (!ultraInsider) return;
    setLoadingActivations(true);
    try {
      const [res1, res2, res3, res4, res5] = await Promise.all([
        getActivationDescribe({
          activation: { ident: "ultra_video_1", withSolutions: true },
        }),
        getActivationDescribe({
          activation: { ident: "ultra_video_2", withSolutions: true },
        }),
        getActivationDescribe({
          activation: { ident: "ultra_video_3", withSolutions: true },
        }),
        getActivationDescribe({
          activation: { ident: "ultra_video_4", withSolutions: true },
        }),
        getActivationDescribe({
          activation: { ident: "ultra_video_5", withSolutions: true },
        }),
      ]);

      setActivationData({
        ultra_video_1: res1,
        ultra_video_2: res2,
        ultra_video_3: res3,
        ultra_video_4: res4,
        ultra_video_5: res5,
      });
    } catch (err) {
      console.error("Activation fetch failed", err);
    } finally {
      setLoadingActivations(false);
    }
  };

  useEffect(() => {
    if (!ultraInsider) return;
    fetchAllActivations();
  }, [ultraInsider]);

  useEffect(() => {
    const scroll = searchParams.get("slider");
    if (!scroll || !sliderRef.current) return;

    requestAnimationFrame(() => {
      const elementTop =
        sliderRef.current.getBoundingClientRect().top + window.pageYOffset;
      const offset = 50;

      window.scrollTo({
        top: elementTop - offset,
      });

      setSearchParams(
        (prev) => {
          prev.delete("slider");
          return prev;
        },
        { replace: true },
      );
    });
  }, [searchParams, ultraInsider, setSearchParams]);

  return (
    <div className="ultra-care">
      <div className="intro">
        <div className="image-device">
          <img src={desktopDevice} alt="Device" />
        </div>
        <div className="content">
          <Logo className="title" />
          <p className="desc">
            Bring dein Vaping-Erlebnis auf die nächste Stufe.
          </p>
        </div>
      </div>

      <div className="features">
        <SectionHeader>
          <strong>App-Funktionen</strong>, die dir gefallen werden
        </SectionHeader>
        <div className="features-wrapper">
          {features.map((data, i) => (
            <div key={i} className="feature-item">
              <img src={data.image} alt={data.title} />
              <div>
                <h3>{data.title}</h3>
                <p>{data.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="how-to">
        <SectionHeader>
          <strong>Videos mit Tipps</strong>
        </SectionHeader>

        <div className="video-wrapper">
          <div className="cta-group">
            <div className="swiper-button-prev video-prev">
              <ArrowButton reverse />
            </div>
            <div className="swiper-button-next video-next">
              <ArrowButton />
            </div>
          </div>
          <Swiper
            spaceBetween={16}
            slidesPerView={1.2}
            breakpoints={{
              640: {
                slidesPerView: 2,
                spaceBetween: 16,
              },
              1020: {
                slidesPerView: 3,
                spaceBetween: 24,
              },
            }}
            modules={[Navigation]}
            navigation={{
              nextEl: ".swiper-button-next.video-next",
              prevEl: ".swiper-button-prev.video-prev",
            }}
          >
            {ultraInsider &&
              activationData &&
              videoCards.map((data) => (
                <SwiperSlide key={data.ident}>
                  <VideoCard
                    fetchAllActivations={fetchAllActivations}
                    {...data}
                    ultraInsider={ultraInsider}
                    activationDescribe={activationData[data.ident]}
                  />
                </SwiperSlide>
              ))}

            {!ultraInsider &&
              videoCards.map((data) => (
                <SwiperSlide key={data.ident}>
                  <VideoCard
                    {...data}
                    ultraInsider={ultraInsider}
                    activationDescribe={undefined}
                  />
                </SwiperSlide>
              ))}
          </Swiper>
        </div>
      </div>

      {ultraInsider ? (
        <>
          <div className="diagnostic-app">
            <SectionHeader>
              <strong>Smartes Diagnose Tool</strong>
            </SectionHeader>
            <div className="diagnostic-wrapper">
              <div className="image-wrapper">
                <img src={diagnosticBg} alt="Smartes Diagnose Tool" />
              </div>
              <div className="diagnostic-content-wrapper">
                <p className="diagnostic-content">
                  <strong>Stimmt etwas nicht? Wir unterstützen dich! </strong>
                  <br />
                  Mit dem Smartes Diagnose Tool kannst du Probleme mit deinem
                  Vuse Ultra schnell erkennen und lösen.
                </p>

                <div className="diagnostic-features">
                  {diagnosticFeatures.map((data, i) => (
                    <div key={i} className="diagnostic-feature-item">
                      <img src={data.image} alt={data.title} />
                      <h3>{data.title}</h3>
                    </div>
                  ))}
                </div>
                <Button
                  btnClass="ultra-insider"
                  href="https://vuse.com/de/de/e-zigaretten/vuse-ultra/vuse-ultra-care/#smartDiagnosticTool"
                >
                  Diagnose starten
                </Button>
              </div>
            </div>
          </div>

          <div className="download">
            <SectionHeader>
              <strong>Die MYVUSE App</strong> herunterladen
            </SectionHeader>
            <div ref={sliderRef} className="download-wrapper">
              <DownloadSlider />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="download">
            <SectionHeader>
              <strong>Die MYVUSE App</strong> herunterladen
            </SectionHeader>
            <div ref={sliderRef} className="download-wrapper">
              <DownloadSlider />
            </div>
          </div>

          <div className="diagnostic-app">
            <SectionHeader>
              <strong>Smartes Diagnose Tool</strong>
            </SectionHeader>
            <div className="diagnostic-wrapper">
              <div className="image-wrapper">
                <img src={diagnosticBg} alt="Smartes Diagnose Tool" />
              </div>
              <div className="diagnostic-content-wrapper">
                <p className="diagnostic-content">
                  <strong>Stimmt etwas nicht? Wir unterstützen dich! </strong>
                  <br />
                  Mit dem Smartes Diagnose Tool kannst du Probleme mit deinem
                  Vuse Ultra schnell erkennen und lösen.
                </p>

                <div className="diagnostic-features">
                  {diagnosticFeatures.map((data, i) => (
                    <div key={i} className="diagnostic-feature-item">
                      <img src={data.image} alt={data.title} />
                      <h3>{data.title}</h3>
                    </div>
                  ))}
                </div>
                <Button
                  btnClass="ultra-insider"
                  href="https://vuse.com/de/de/e-zigaretten/vuse-ultra/vuse-ultra-care/#smartDiagnosticTool"
                >
                  Diagnose starten
                </Button>
              </div>
            </div>
          </div>
        </>
      )}

      <Faq />
    </div>
  );
}
